import type {AddServiceDescriptionFormPayload} from "./add-service-description.schema";

import {addServiceDescription} from "@project/sdk/engineering";
import {mutationOptions} from "@tanstack/react-query";

import {serviceKeys, serviceMutationKeys} from "../../../../../service-keys";

export function addServiceDescriptionMutationOptions(id: string) {
  return mutationOptions({
    mutationKey: serviceMutationKeys.addServiceDescription,
    mutationFn: (payload: AddServiceDescriptionFormPayload) => addServiceDescription(id, payload),
    onSuccess: async (_result, _variables, _context, {client}) => {
      await Promise.all([
        client.invalidateQueries({queryKey: serviceKeys.detail(id)}),
        client.invalidateQueries({queryKey: serviceKeys.lists()}),
      ]);
    },
  });
}
